import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentKeys } from 'app/_models/environmentKeys';
import { CookieManagementEnum } from 'app/general/_models/cookieManagementEnum';

declare const crisp: any;

@Injectable({
    providedIn: 'root'
})
export class ScriptService {
    private environmentKeys: EnvironmentKeys;

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.environmentKeys = new EnvironmentKeys();
    }

    public createCrispScript(): void {
        const head = this.document.getElementsByTagName('head')[0];

        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.text = ` $crisp = [];
                        CRISP_WEBSITE_ID = '${this.environmentKeys.crispWebsiteId}';
                        CRISP_RUNTIME_CONFIG = { autoload: false };
                        (function () { d = document; s = d.createElement('script'); s.src = 'https://client.crisp.chat/l.js'; s.async = 1; d.getElementsByTagName('head')[0].appendChild(s); })();`;

        head.appendChild(script);
    }

    public createGoogleAnalyticsScript(acceptedCookies: number): void {
        const hasAccepted = (acceptedCookies & CookieManagementEnum.Google) == CookieManagementEnum.Google;

        const oldScript = document.getElementById("google-analytics");
        const oldScriptGA = document.getElementById("google-analytics-external");
        const head = this.document.getElementsByTagName('head')[0];

        const scriptGA = this.document.createElement('script');
        scriptGA.async = true;
        scriptGA.src = `https://www.googletagmanager.com/gtm.js?id=${this.environmentKeys.googleAnalyticsKey}`;
        scriptGA.id = 'google-analytics-external';

        oldScriptGA?.remove();

        if (hasAccepted)
            head.appendChild(scriptGA);

        const script = this.document.createElement('script');
        script.id = 'google-analytics'
        script.type = 'text/javascript';

        script.text = `window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('consent', 'default', {
                                'ad_storage': ${ hasAccepted ? `'granted'` : `'denied'` },
                                'analytics_storage': ${ hasAccepted ? `'granted'` : `'denied'` }
                            });
                            gtag('js', new Date());
                            window['ga-disable-${this.environmentKeys.googleAnalyticsKey}'] = ${!hasAccepted};
                            gtag('config', '${this.environmentKeys.googleAnalyticsKey}', {
                                'storage': ${ hasAccepted ? `'default'` : `'none'` },
                                'client_storage': ${ hasAccepted ? `'default'` : `'none'` }
                            });`;

        oldScript?.remove();
        head.appendChild(script);
    }

    public exitGoogleAnalyticsScript() {
        document.cookie.split(";").forEach(cookie => {
            const cookieName = cookie.split("=")[0].trim();
            if (cookieName.startsWith("_ga")) {
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        });

        const head = this.document.getElementsByTagName('head')[0];
        const oldScript = document.getElementById("google-analytics");

        const script = this.document.createElement('script');
        script.id = 'google-analytics'
        script.type = 'text/javascript';

        script.text = ` window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('consent', 'default', {
                            'ad_storage': 'denied',
                            'analytics_storage': 'denied'
                        });
                        gtag('js', new Date());
                        window['ga-disable-${this.environmentKeys.googleAnalyticsKey}'] = true;
                        gtag('config', '${this.environmentKeys.googleAnalyticsKey}', {
                            'storage': 'none',
                            'client_storage': 'none'
                        });`;

        if (oldScript)
            head.replaceChild(script, oldScript);
    }
}
